import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="flex items-center gap-3 text-xs font-bold tracking-[0.3em] uppercase text-[#D40000]">
    <span className="inline-block h-px w-8 bg-[#D40000]" />
    {children}
  </p>
);
